module.exports = __webpack_public_path__ + "static/media/screen-3.37fa480e.svg";